import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SapService } from 'src/app/api/sap.service';
import { variableGlobal } from 'src/app/global.enum';
import { listaClienteComponent } from '../../venta/listaCliente';
import { DocumentoMarting } from 'src/app/model/ventaModel';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { query } from '@angular/animations';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-crear-oportunidad',
  templateUrl: './crear-oportunidad.component.html',
  styleUrls: ['./crear-oportunidad.component.css']
})
export class CrearOportunidadComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _sap: SapService,
    private modalService: NgbModal,
    private _api: IntranetoldService,
    ) { }
  cargando: boolean = false;
  Etapas:any;
  crearDesdeSegumiento:boolean;
  documento:any;
  listaVendedor:any;
  body = {
    "OpprId": -1,
    "CardCode": "",
    "SlpCode": -1,
    "CprCode": 0,
    "Source": null,
    "IntCat1": null,
    "IntCat2": null,
    "IntCat3": null,
    "IntRate": null,
    "OpenDate": "2023-09-28T00:00:00",
    "DifType": "D",
    "PredDate": '2023-09-28T00:00:00',
    "MaxSumLoc": 0,
    "MaxSumSys": 1.0,
    "WtSumLoc": 0,
    "WtSumSys": 1.0,
    "PrcnProf": 0.0,
    "SumProfL": 0.0,
    "SumProfS": 0.0,
    "Memo": "PRUEBA INDESAD",
    "Status": "O",
    "StatusRem": null,
    "Reason": null,
    "RealSumLoc": 1000,
    "RealSumSys": 1.0,
    "RealProfL": 0.0,
    "RealProfS": 0.0,
    "CloPrcnt": 0,
    "StepLast": 5,
    "UserSign": 1,
    "Transfered": "false",
    "Instance": 0,
    "CardName": "",
    "CloseDate": null,
    "LastSlp": -1,
    "Name": "",
    "Territory": null,
    "Industry": null,
    "ChnCrdCode": null,
    "ChnCrdName": null,
    "PrjCode": null,
    "CardGroup": 102,
    "ChnCrdCon": null,
    "Owner": null,
    "attachment": null,
    "DocType": "-1",
    "DocNum": null,
    "DocEntry": null,
    "DocChkbox": false,
    "AtcEntry": null,
    "LogInstanc": 0,
    "UserSign2": null,
    "UpdateDate": "2023-09-28T00:00:00",
    "OpprType": "R",
    "UpdateTS": 234732,
    "DPPStatus": false,
    "CreateDate": "",
    "EncryptIV": null,
    "DataVers": 1,
    "userFields": [],
    "OPR1": [
        {
            "OpprId": -1,
            "Line": -1,
            "SlpCode": -1,
            "CntctCode": null,
            "OpenDate": null,
            "Step_Id": 1,
            "ClosePrcnt": 0,
            "MaxSumLoc": 0,
            "MaxSumSys": 1.0,
            "Memo": "",
            "DocId": null,
            "ObjType": "-1",
            "Status": "O",
            "Linked": "false",
            "WtSumLoc": 0,
            "WtSumSys": 1.0,
            "UserSign": null,
            "ChnCrdCode": null,
            "ChnCrdName": null,
            "ChnCrdCon": null,
            "DocChkbox": null,
            "Owner": null,
            "DocNumber": null,
            "EncryptIV": null,
            "userFields": []
        }
    ],
    "OPR2": [],
    "OPR3": [],
    "OPR4": [],
    "OPR5": []
  }

  DocumentoMarting: DocumentoMarting = {

    OCBase64Nombre:"",
    OCBase64Formato:"",
    OCBase64:"",
    UserFields: [
     {
        Field: "U_IND_ESTADO_WMS",
        FieldType: "String",
        Value: "SA",
      },
       /*
      {
        Field: "U_IND_COMENTARIO_FACTURA",
        FieldType: "String",
        Value: "",
      }*/
    ],
    Draft: false,
    SubObjType: null,
    DocEntry: -1,
    DocNum: -1,
    Rate: 1,
    CardCode: null,
    CardName: null,
    Currency: "CLP",
    NumAtCard: null,
    Series: -1,
    DocType: "I",
    ShipToCode: null,
    PayToCode: null,
    Address: null,
    Address2: null,
    GroupNum: null,
    GroupCode: null,
    TrnspCode: null,
    U_IND_Tipo_E: null,
    TaxDate: null,
    DocDueDate: null,
    DocDate: null,
    ObjType: null,
    SlpCode: -1,
    OwnerCode: null,
    Comments: "",
    GrossProfit: 0,
    DiscPrcnt: 0,
    DiscTotal: 0,
    TotalExpns: 0,
    VatSum: 0,
    DocTotal: 0,
    DescuentoCampoUsuario: 10,
    Detalles: [],
    BillToDef: null,
    ShipToDef: null,
    ListaDePrecioSocio: null,
    ListaCUrrency: false,

    AddresList: {
      StreetS: null,
      StreetNoS: null,
      BlockS: null,
      CityS: null,
      ZipCodeS: null,
      CountyS: null,
      StateS: null,
      CountryS: null,
      BuildingS: null,
      Address2S: null,
      Address3S: null,
      GlbLocNumS: null,
      StreetB: null,
      StreetNoB: null,
      BlockB: null,
      CityB: null,
      ZipCodeB: null,
      CountyB: null,
      StateB: null,
      CountryB: null,
      BuildingB: null,
      Address2B: null,
      Address3B: null,
      GlbLocNumB: null,
    }
  };

  async ngOnInit(): Promise<void> {

    let listaVendedor:any = await this.obtieneQueryMongo('listaVendedor');
    listaVendedor = await this._api.GetNotFileQuery(listaVendedor);
    this.listaVendedor = listaVendedor.objeto;


    let Etapas:any = await this.obtieneQueryMongo('OportunidadEtapas');
    Etapas = await this._api.GetNotFileQuery(Etapas);
    this.Etapas = Etapas.objeto;
    

    if (this.documento) {
      this.body.CardCode = this.documento.CardCode;
      this.body.CardName = this.documento.CardName;
      this.body.OPR1[0].MaxSumLoc = this.documento.GrossProfit;
    }

    if (!this.body.CreateDate) {
      let createDate = new Date();
      this.body.CreateDate = this.formatDateToDDMMYYYY(createDate)

    }

    

    

  }

  formatDateToDDMMYYYY(date: any): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${year}-${month}-${day}`;
}

  async guardar(){
    this.cargando = true;

    this.body.OPR1[0].WtSumLoc = this.body.OPR1[0].MaxSumLoc * (this.body.OPR1[0].ClosePrcnt / 100);
    this.body.MaxSumLoc = this.body.OPR1[0].MaxSumLoc;
    this.body.CloPrcnt = this.body.OPR1[0].ClosePrcnt;
    this.body.WtSumLoc = this.body.MaxSumLoc * (this.body.CloPrcnt / 100);

    this.body.CreateDate = this.obtenerFechaActualEnFormato(this.body.CreateDate);
    this.body.OpenDate = this.obtenerFechaActualEnFormato(this.body.CreateDate);
    this.body.PredDate = this.obtenerFechaActualEnFormato(this.body.PredDate);
    this.body.UpdateDate = this.obtenerFechaActualEnFormato(this.body.UpdateDate);
    this.body.OPR1[0].OpenDate = this.body.OpenDate;

    this.Etapas.forEach(element => {
      if (element.StepId == this.body.OPR1[0].Step_Id) {
        this.body.CloPrcnt = element.CloPrcnt;
      }
    });

    

    let res:any = await this._sap.creaActualizaOportunidad(this.body);

    if (res.estado) {

      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'success',
        title: res.mensaje
      });

      this.activeModal.close();

    }
    else
    {
      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'error',
        title: res.mensaje
      });
    }

    this.cargando = false;
  }

  cerrar() {
    this.activeModal.close();
  }

  async selecionarCliente() {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(listaClienteComponent, ngbModalOptions);
    //modalRef.componentInstance.data = this.OCRD;
    modalRef.componentInstance.PriceList = this.DocumentoMarting.ListaDePrecioSocio;
    modalRef.componentInstance.Encabezado = this.DocumentoMarting;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then(async (data) => {
      if (data) {
        
        this.body.CardCode = data.CardCode;
        this.body.CardName = data.CardName;
      }
    }, (reason) => {
      //this.editar(item);
    });

  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });

    return query;
  }

  obtenerFechaActualEnFormato(date?): string {

    let fecha = new Date();

    if (date) {
      fecha = new Date(date)
    }

    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes comienza desde 0
    const dia = fecha.getDate().toString().padStart(2, '0');
    const horas = '00';
    const minutos = '00';
    const segundos = '00';

    const fechaFormateada = `${año}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    return fechaFormateada;
  }

}
